const PATH = {
  PO_BASE_URL: process.env.REACT_APP_PO_SERVER_URL,
  MDM_BASE_URL: process.env.REACT_APP_MDM_SERVER_URL,
  SI_BASE_URL: process.env.REACT_APP_SI_SERVER_URL,
  PURCHASE_ORDER: {
    po_order: '/purchase-order',
    options: '/purchase-order/options',
    list: '/purchase-order/list',
    summary: '/purchase-order/summary',
    filters: '/purchase-order/filters',
    exportPDF: '/purchase-order/exportpdf',
    details: '/details',
    commentsDownload: '/comments-download',
    commentsUpload: '/comments-upload',
    exportCSV: '/export-csv/',
    filesSubmit: '/files-submit',
    forceClose: '/force-close',
    validateSKU: '/sku-validate',
    sync: '/sync',
    updatePO: '/update',
    skuSample: '/sku-sample',
    updateQtySample: '/update-sku-qty-sample',
    new_po_order: '/purchase-order/new',
    new_inter_entity_po_order: '/purchase-order/new-inter-entity-billing-po',
    event: '/event',
    sampleCommentDownload: '/sample-comment-download',
    skuValidateUpdateQty: '/sku-validate-updated-qty',
    skuSubmitUpdateQty: '/sku-submit-updated-qty',
    skuValidateClone: '/sku-validate-clone'
  },
  ASN: {
    asn: '/asn',
    asnNew: '/asn/new',
    list: '/asn/list',
    summary: '/asn/summary',
    filters: '/asn/filters',
    idDetails: '/details',
    update: '/update',
    updateFields: '/update-fields',
    requiredFiles: '/required-files',
    skuSample: '/asn/sku-sample',
    filesSubmit: '/files-submit',
    commentsUpload: '/comments-upload',
    event: '/event',
    validatePackingList: '/validate-packing-list',
    sampleCommentDownload: '/sample-comment-download',
    validatePackingListOnUpload: '/validate-packing-list-on-upload'
  },
  GRN: {
    grn: '/grn',
    list: '/grn/list',
    summary: '/grn/summary',
    filters: '/grn/filters',
    facilities: '/grn/facilities',
    details: '/details',
    update: '/update',
    skuSample: '/grn/sku-sample',
    validateSKU: '/sku-validate',
    filesSubmit: '/files-submit',
    commentsUpload: '/comments-upload',
    filesUpdate: '/files-update',
    requiredFiles: '/required-files',
    excessSkuFile: '/excess-sku-file',
    exportPdf: '/exportpdf'
  },
  INTERNATIONAL_INVENTORY: {
    list: '/international-inventory/list',
    filters: '/international-inventory/filters'
  },
  COMMENTS: {
    commentsHistory: '/comments/history'
  },
  HISTORY: {
    history: '/event-history'
  },
  ATTACHMENT_HISTORY: {
    attachment: '/attachment-history',
    delete: '/delete'
  },
  ATTACHMENT: {
    attachment: '/attachment',
    upload: '/upload',
    delete: '/attachment/delete',
    downloadZip: '/attachment/download-zip',
    downloadHistoryZip: '/attachment-history/download-zip'
  },
  MDM: {
    ENTITY: {
      entity: '/entity',
      brandEntity: '/entity/brand-entity',
      exportOrderEntity: '/entity/export-order-entities-by-type',
      markUp: '/entity-markup/markup-details-by-entity',
      port: '/entity?entityType=PORT'
    },
    TERMS_CONDITIONS: {
      termsConditions: '/terms-and-conditions',
      termsOfDelivery: '/terms-of-delivery-and-payment-master'
    },
    BRANDS: {
      brand: '/brand'
    },
    TRANSPORT: {
      transport: '/transport',
      transportDocDetails: 'transport/doc-details'
    },
    VENDOR_AGREEMENT: {
      check: '/vendor-agreement/check',
      accept: '/vendor-agreement/accept'
    }
  },
  SALES: {
    SALES_ORDER: {
      si_so: '/v1/si/so',
      si_eo: '/v1/si/eo',
      si_ro: '/v1/ro',
      validateSKU: '/v1/si/so/sku-validate',
      eoValidateSKU: '/sku-validate',
      deleteSKU: '/v1/si/so/delete-sku',
      options: '/v1/si/so/options',
      manualSOCreation: '/v1/si/so/create/manual',
      details: '/v1/si/so/details',
      downloadSKUList: '/v1/si/so/download/sku-list',
      generateProformaInvoice: '/v1/si/so/generate-proforma-invoice',
      inventoryValidation: '/inventory-validation',
      markAsOpen: '/v1/si/so/open',
      generateCsv: '/generate-csv',
      cancelSO: '/v1/si/so/cancel',
      list: '/v1/si/so/list',
      eoList: '/v1/si/eo/list',
      summary: '/v1/si/so/summary',
      eoSummary: '/v1/si/eo/summary',
      filters: '/v1/si/so/filters',
      eoFilters: '/v1/si/eo/filters',
      submitSKU: '/sku-submit',
      createSO: '/v1/si/so/create',
      uploadReceipts: '/v1/si/so/upload/receipts',
      edit: '/v1/si/so/edit',
      validateSOPack: '/v1/si/so/pack-validate',
      packingDetailsValidate: '/v1/si/so/packing-details-validate',
      samplePack: '/v1/si/so/pack-sample',
      packingDetailsSample: '/v1/si/so/packing-details-sample',
      sample: '/v1/si/so/sample',
      submitPack: '/v1/si/so/pack-submit',
      packingDetailsSubmit: '/v1/si/so/packing-details-submit',
      clearTaxTaxInvoicePreGenerate: '/v1/si/cleartax/tax-invoice/pre-generate',
      addAppointment: '/add-appointment',
      editAppointment: '/edit-appointment',
      uploadEpod: '/upload-epod',
      epodManualUpload: '/epod-data/manual-upload',
      epodCancel: '/epod-data/cancel',
      bulkEpodManualUploadSample: '/v1/si/so/bulk-epod-manual-upload-sample',
      bulkEpodManualUploadValidate: '/v1/si/so/bulk-epod-manual-upload-validate',
      bulkEpodManualUploadSubmit: '/v1/si/so/bulk-epod-manual-upload-submit',
      cancelAppointment: '/cancel-appointment',
      removeAppointment: '/remove-appointment',
      deleteAttachment: '/v1/si/so/delete-attachment',
      approve: '/approve',
      reject: '/reject',
      sendForApproval: '/send-for-approval',
      shortQtyCreditNoteCancel: '/short-qty-credit-note/cancel',
      fetchRemarks: '/v1/si/so/fetch-remarks'
    },
    CUSTOMER_PO: {
      si_po: '/v1/si/po',
      downloadSample: '/v1/si/po/download-sample',
      deleteSKU: '/delete-sku',
      validateSKU: '/sku-validate',
      sync: '/sync',
      options: '/v1/si/po/options',
      details: '/v1/si/po/details',
      closePO: '/v1/si/po/close',
      cancelPO: '/v1/si/po/cancel',
      list: '/v1/si/po/list',
      summary: '/v1/si/po/summary',
      filters: '/v1/si/po/filters',
      submitSKU: '/sku-submit',
      uploadPO: '/upload-po',
      editPO: '/edit-po',
      createPO: '/v1/si/po/create-po',
      sendForAllocation: '/send-for-allocation',
      allocatePO: '/v1/si/po/allocate',
      downloadSKUList: '/sku-download'
    },
    GRN: {
      grnIdDetails: '/v1/si/grn/grn-details',
      createSearch: 'v1/si/grn/create-search',
      sampleGRN: '/v1/si/grn/sample-grn',
      list: '/v1/si/grn/list',
      eoList: '/v1/si/eo/grn/list',
      summary: '/v1/si/grn/summary',
      eoSummary: '/v1/si/eo/grn/summary',
      filters: '/v1/si/grn/filters',
      eoFilters: '/v1/si/eo/grn/filters',
      createGRN: '/v1/si/grn/create',
      cancelGRN: '/v1/si/grn/cancel',
      closeGRN: '/v1/si/grn/close',
      submitSKU: '/v1/si/grn/sku-submit',
      validateSKU: '/v1/si/grn/sku-validate',
      uploadAttachment: '/v1/si/grn/upload-attachment'
    },
    RO_GRN: {
      grnIdDetails: '/v1/ro/grn'
    },
    CLEAR_TAX: {
      generateIRN: '/v1/si/cleartax/irn/generate',
      generateEwaybill: '/v1/si/cleartax/ewaybill/generate',
      generateDeliveryChallan: '/v1/si/cleartax/delivery-challan/generate'
    },
    RO: {
      list: '/v1/si/ro/list',
      filters: '/v1/si/ro/filters',
      skuValidation: '/v1/si/ro/sku-validate',
      createOrders: '/v1/si/ro/sku-validate'
    },
    BULK_APPOINTMENT_DOWNLOAD: {
      // TASK-4450: bulk download of appointment files by LR number
      // Accepts a multipart CSV of LR numbers, returns a ZIP (success) or an enriched error CSV (failure).
      download: '/v1/si/so/bulk-appointment-download',
      downloadSample: '/v1/si/so/bulk-appointment-download-sample'
    }
  }
};

export { PATH };
